<h2 mat-dialog-title>{{ "Importerer dokumenter fra Google Drive"|translate }}</h2>
<opplastingsstatus-skyfiler [filerUnderOpplasting]="valgteFilerMedOpplastingsstatus()"
                            [nyeVersjoner]="dokumenterMedNyVersjon()"
                            [modus]="opplastingsstatusModus()"
                            (vedStartOpplasting)="startOpplasting()"
                            (vedAvbryt)="avbrytLastOpp()"
                            (vedLukk)="lukk()"/>
